import React from 'react'

import { TextField } from "@aws-amplify/ui-react";

import { Container } from './Styled';

export default function FullNameContainer({
  handleChange,
  given_name,
  family_name
}: any) {
  return (
    <Container>
    <TextField label="First Name" aria-label="Enter your first name" id="firstName" onChange={(e: any) => handleChange('firstName', e)} value={given_name} isRequired={true} />
    <TextField label="Last Name" aria-label="Enter your last name" id="lastName"onChange={(e: any) => handleChange('lastName', e)} value={family_name} isRequired={true} />
  </Container>
  );
}
